document.getElementsByClassName('nav_link')[0].addEventListener('click', (e) => {
	e.preventDefault();
	document.body.classList.toggle('nav-active');
});